/* globals google */
'use strict';

import styles from './mapStyles';
import { appendToUrl } from '../util/common';
import { applyRendering } from '../util/render';
import StoreHours from 'storeLocator/storeHours';
import { woosmapInitFindYourStore } from '../woosmap';
import ProfileEnrich from '../profileEnrich';
const MarkerClusterer = require('@google/markerclusterer');

/**
 * Creates the HTML to show information about the store
 * @param {Object} store The store to show information about
 */
function createHTMLForInfoWindow (store) {
    var storeData = {
        latitude: store.latitude,
        longitude: store.longitude,
        URL: store.URL,
        name: store.name,
        address1: store.address1,
        address2: store.address2,
        postalCode: store.postalCode,
        city: store.city,
        stateCode: store.stateCode,
        distance: store.distance,
        phone: store.phone,
        hours: $('#' + store.ID + ' .store-hours-current').html()
    };
    var infoWindowHtml = applyRendering('storeName', storeData);
    infoWindowHtml += applyRendering('storeHours', storeData);
    if (store.phone) {
        infoWindowHtml += applyRendering('storePhone', storeData);
    }
    return infoWindowHtml;
}

/**
 * Uses google maps api to render a map
 */
function maps (initialCoords = {lat: 37.09024, long: -95.712891}) {
    var map;
    var labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var labelIndex = 0;
    var infowindow = new google.maps.InfoWindow();

    // Init U.S. Map in the center of the viewport
    var latlng = new google.maps.LatLng(initialCoords.lat, initialCoords.long);
    var mapOptions = {
        scrollwheel: false,
        zoom: 12,
        center: latlng,
        styles
    };

    map = new google.maps.Map($('.map-canvas')[0], mapOptions);
    var mapdiv = $('.map-canvas').attr('data-locations');

    mapdiv = JSON.parse(mapdiv);

    var bounds = new google.maps.LatLngBounds();

    // This is needed to set the zoom after fitbounds,
    google.maps.event.addListener(map, 'zoom_changed', function () {
        var zoomChangeBoundsListener = google.maps.event.addListener(map, 'bounds_changed', function (event) {
            if (this.getZoom() > 14 && this.initialZoom === true) {
                // Change max/min zoom here
                this.setZoom(14);
                this.initialZoom = false;
            }
            google.maps.event.removeListener(zoomChangeBoundsListener);
        });
    });

    map.initialZoom = true;

    var markerUrl = {
        url: $('.map-canvas').data('marker-url'),
        labelOrigin: new google.maps.Point(8, 9)
    };

    const markers = [];
    Object.keys(mapdiv).forEach(function (key) {
        var item = mapdiv[key];
        var storeLocation = new google.maps.LatLng(item.latitude, item.longitude);
        var marker = new google.maps.Marker({
            position: storeLocation,
            map: map,
            title: item.name,
            icon: markerUrl,
            label: { text: labels[labelIndex++ % labels.length], color: 'white', fontSize: '12px' }
        });
        markers.push(marker);

        marker.addListener('click', function () {
            infowindow.setOptions({
                content: createHTMLForInfoWindow(item)
            });
            $('body').trigger('analytics:clickonStoreMarker', item);
            infowindow.open(map, marker);
        });

        // Create a minimum bound based on a set of storeLocations
        bounds.extend(marker.position);
    });
    // Add a marker clusterer to manage the markers.
    const markerCluster = new MarkerClusterer(map, markers,
        {
            imagePath: $('.map-canvas').data('cluster-images') + '/m'
        });

    // Fit the all the store marks in the center of a minimum bounds when any store has been found.
    if (mapdiv && mapdiv.length !== 0) {
        map.fitBounds(bounds);
    }

    // Set map coordinates on result pin click
    const $results = $('.results');
    $results.on('click', '.store-result-marker-button', (e) => {
        map.setCenter({
            lat: Number($(e.currentTarget).data('store-coords').split(',')[0]),
            lng: Number($(e.currentTarget).data('store-coords').split(',')[1])
        });

        map.setZoom(13);

        $('html, body').animate({
            scrollTop: 0
        }, 500);

        e.preventDefault();
    });
}

/**
 * Renders the results of the search and updates the map
 * @param {Object} data - Response from the server
 */
function updateStoresResults (data, coords) {
    var $resultsDiv = $('.results');
    var $mapDiv = $('.map-canvas');
    var hasResults = data.stores.length > 0;

    if (!hasResults) {
        $('.store-locator-no-results').show();
    } else {
        $('.store-locator-no-results').hide();
    }

    $resultsDiv.empty()
        .data('has-results', hasResults)
        .data('radius', data.radius)
        .data('search-key', data.searchKey);

    $mapDiv.attr('data-locations', data.locations);

    if ($mapDiv.data('has-google-api')) {
        const coords = {};
        const searchKeys = $('.results').data('search-key');

        if (searchKeys.lat && searchKeys.long) {
            coords.lat = searchKeys.lat;
            coords.long = searchKeys.long;
        }

        maps(coords);
    } else {
        $('.store-locator-no-apiKey').show();
    }

    if (data.storesResultsHtml) {
        $resultsDiv.append(data.storesResultsHtml);
    }

    StoreHours.run();
}

function geocodeAndSearch (element) {
    const $form = element.closest('.store-locator');
    const query = $form.find('[name="postalCode"]').val();

    if (query.length < 3) {
        return null;
    }

    // Save previous query to avoid Geocoding the same location multiple times
    window.storeLocator.previousQuery = query;

    const geocoder = new google.maps.Geocoder();
    const countryCode = $form.data('country-code') || 'IT';
    geocoder.geocode({'address': query, 'componentRestrictions': {'country': countryCode}}, (res, status) => {
        if (res.length && status === 'OK') {
            const coords = {
                lat: res[0].geometry.location.lat(),
                long: res[0].geometry.location.lng()
            };

            search(element, coords);
        } else {
            console.warn('Geocoding error: ', status);
        }
    });
}

/**
 * Search for stores with new zip code
 * @param {HTMLElement} element - the target html element
 * @returns {boolean} false to prevent default event
 */
function search (element, coords = {lat: null, long: null}) {
    var dialog = element.closest('.in-store-inventory-dialog');
    var spinner = dialog.length ? dialog.spinner() : $.spinner();
    spinner.start();
    var $form = element.closest('.store-locator');
    var radius = $('.results').data('radius');
    var url = $form.attr('action');
    var isEnrichMap = $('.page').data('action').indexOf('Enrich')> -1;
    var urlParams = {
        radius,
        lat: coords.lat,
        long: coords.long,
        isEnrichMap: isEnrichMap
    };

    url = appendToUrl(url, urlParams);

    $.ajax({
        url: url,
        type: $form.attr('method'),
        dataType: 'json',
        success: function (data) {
            spinner.stop();
            updateStoresResults(data);
            $('.select-store').prop('disabled', true);
            let city = $('.store-locator-container').find('#store-postal-code').val() ? $('.store-locator-container').find('#store-postal-code').val().split(',')[0] : '';
            $('body').trigger('storeLocator:searchWithZipCode', {data, action: 'search_for_a_shop', city: city});
            ProfileEnrich.initFavouriteStore();
        }
    });
    return false;
}

function woosmapListener () {
    $('body').on('woosmap:chooseOptionFindYourStore', function (e, selection) {
        if (selection.geometry && selection.geometry.location.lat && selection.geometry.location.lng) {
            const coords = {
                lat: selection.geometry.location.lat,
                long: selection.geometry.location.lng
            };

            search($('.store-locator-container form.store-locator'), coords, true);
        } else {
            // Log failure to the console as warning
            console.warn('Geocoding via Woosmap failed.');
            $.spinner().stop();
        }
    });
}

module.exports = {
    init: function () {
        window.storeLocator = {};
        window.storeLocator.previousQuery = '';

        if ($('.map-canvas').data('has-google-api')) {
            const coords = {};
            const searchKeys = $('.results').data('search-key');

            if (searchKeys.lat && searchKeys.long) {
                coords.lat = searchKeys.lat;
                coords.long = searchKeys.long;
            }

            maps(coords);
        } else {
            $('.store-locator-no-apiKey').show();
        }

        woosmapInitFindYourStore();
        woosmapListener();
    },

    detectLocation: function () {
        // clicking on detect location.
        $('.detect-location').on('click', function () {
            $('.store-locator').find('.localities-empty-button').trigger('click');
            $.spinner().start();
            if (!navigator.geolocation) {
                $.spinner().stop();
                return;
            }

            navigator.geolocation.getCurrentPosition(function (position) {
                var $detectLocationButton = $('.detect-location');
                var url = $detectLocationButton.data('action');
                var radius = $('.results').data('radius');
                var urlParams = {
                    radius: radius,
                    lat: position.coords.latitude,
                    long: position.coords.longitude
                };

                url = appendToUrl(url, urlParams);

                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $.spinner().stop();
                        $('body').trigger('storeLocator:geolocationSucceeded', data);
                        updateStoresResults(data);
                        $('.select-store').prop('disabled', true);
                        ProfileEnrich.initFavouriteStore();
                    }
                });
            }, function (error) {
                console.log('Error: ' + error);
                $.spinner().stop();
            });
        });
    },

    search: function () {
        $('.store-locator-container form.store-locator').submit(function (e) {
            e.preventDefault();
            // $('body').trigger('storeLocator:searchWithZipCode');
            // geocodeAndSearch($(this));
        });
        $('.store-locator-container .btn-storelocator-search[type="button"]').click(function (e) {
            e.preventDefault();
            // $('body').trigger('storeLocator:searchWithZipCode');
            // geocodeAndSearch($(this));
        });
    },

    changeRadius: function () {
        $('.store-locator-container .radius').change(function (e) {
            var radius = $(e.target).val();
            var searchKeys = $('.results').data('search-key');
            var url = $('.radius').data('action-url');
            var urlParams = {};

            if (searchKeys.postalCode) {
                urlParams = {
                    radius: radius,
                    postalCode: searchKeys.postalCode
                };
            } else if (searchKeys.lat && searchKeys.long) {
                urlParams = {
                    radius: radius,
                    lat: searchKeys.lat,
                    long: searchKeys.long
                };
            }

            url = appendToUrl(url, urlParams);

            var dialog = $(this).closest('.in-store-inventory-dialog');
            var spinner = dialog.length ? dialog.spinner() : $.spinner();
            spinner.start();
            $.ajax({
                url: url,
                type: 'get',
                dataType: 'json',
                success: function (data) {
                    spinner.stop();
                    updateStoresResults(data);
                    $('.select-store').prop('disabled', true);
                }
            });
        });
    },
    selectStore: function () {
        $('.store-locator-container').on('click', '.select-store', function (e) {
            e.preventDefault();
            var selectedStore = $(':checked', '.results-card .results');
            var data = {
                storeID: selectedStore.val(),
                searchRadius: $('#radius').val(),
                searchPostalCode: $('.results').data('search-key').postalCode,
                storeDetailsHtml: selectedStore.siblings('label').find('.store-details').html(),
                event: e
            };

            $('body').trigger('store:selected', data);
        });
    },
    updateSelectStoreButton: function () {
        $('body').on('change', '.select-store-input', function () {
            $('.select-store').prop('disabled', false);
        });
    },

    initStoreHours: function () {
        StoreHours.run();
    }
};
